<div class="qty-details-tooltip" (click)="$event.stopPropagation()">
  <div class="tooltip-header">
    {{ 'quotations_and_orders.side_by_side_panel.quantity_details' | translate }}
  </div>

  <div class="tooltip-body">
    <!-- AI parsed data row -->
    <div class="tooltip-row">
      <span class="row-label">
        {{ 'quotations_and_orders.side_by_side_panel.parsed_data' | translate }}
        <ui-svg-icon svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
      </span>
      <span class="row-value">{{ parsedData || '--' }}</span>
    </div>
    <div class="tooltip-note" *ngIf="showConversionNote">
      {{ 'quotations_and_orders.side_by_side_panel.sub_unit_conversion_note' | translate }}
    </div>

    <!-- Default (preferred selling) unit -->
    <div class="tooltip-row" *ngIf="hasPreferredSellingUnit">
      <span class="row-label">{{ 'quotations_and_orders.side_by_side_panel.qty_tooltip_default_unit' | translate }}</span>
      <span class="row-value">{{ item.quantity_preferred_selling_unit }} {{ item.quantity_preferred_selling_unit_name }}</span>
    </div>

    <!-- Base units -->
    <div class="tooltip-row">
      <span class="row-label">{{ 'quotations_and_orders.side_by_side_panel.qty_tooltip_base_units' | translate }}</span>
      <span class="row-value">{{ item.quantity }} {{ 'quotations_and_orders.side_by_side_panel.units_suffix' | translate }}</span>
    </div>
    <div class="tooltip-note" *ngIf="hasBaseUnitsConversion">
      {{ 'quotations_and_orders.side_by_side_panel.quantity_in_base_units' | translate: baseUnitsParams }}
    </div>
  </div>

  <!-- Footer: ordered quantity in the matched selling unit -->
  <div class="tooltip-footer">
    <span class="footer-label">{{ 'quotations_and_orders.side_by_side_panel.order_quantity' | translate }}</span>
    <span class="footer-value" *ngIf="selectedHu; else noHuFooter">
      {{ item.quantity_handling_unit }} {{ selectedHu.name }}
    </span>
    <ng-template #noHuFooter>
      <span class="footer-value">{{ item.quantity }} {{ 'quotations_and_orders.side_by_side_panel.units_suffix' | translate }}</span>
    </ng-template>
  </div>
</div>
